module.exports = "data:text/x-markdown;base64,CkEgY29udHJhY3QgY3JlYXRvciBoYXMgYnVpbHQgYSB2ZXJ5IHNpbXBsZSB0b2tlbiBmYWN0b3J5IGNvbnRyYWN0LiBBbnlvbmUgY2FuIGNyZWF0ZSBuZXcgdG9rZW5zIHdpdGggZWFzZS4gQWZ0ZXIgZGVwbG95aW5nIHRoZSBmaXJzdCB0b2tlbiBjb250cmFjdCwgdGhlIGNyZWF0b3Igc2VudCBgMC41YCBldGhlciB0byBvYnRhaW4gbW9yZSB0b2tlbnMuIFRoZXkgaGF2ZSBzaW5jZSBsb3N0IHRoZSBjb250cmFjdCBhZGRyZXNzLiAKClRoaXMgbGV2ZWwgd2lsbCBiZSBjb21wbGV0ZWQgaWYgeW91IGNhbiByZWNvdmVyIChvciByZW1vdmUpIHRoZSBgMC41YCBldGhlciBmcm9tIHRoZSBsb3N0IGNvbnRyYWN0IGFkZHJlc3MuIAo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/recovery.md
// module id = 1401
// module chunks = 0